module.exports = __webpack_public_path__ + "static/media/workers-min.fefea27c.jpg";